import { Fragment } from 'react';
import PropTypes from 'prop-types'
import _get from 'lodash/get';
import { useQuery } from '@apollo/client';
import Typography from '@material-ui/core/Typography';
import Loading from '../loading';
import ErrorMessage from '../error-message';
import NotFound from '../not-found';
import AttendeesList from './attendees-list';
import { eventAttendeesQuery } from '../../apollo/events';

const EventAttendeesTab = ({ event }) => {
  const { data, loading, error } = useQuery(eventAttendeesQuery, {
    variables: {
      id: event.id,
    },
  });
  const attendeesEvent = _get(data, 'event');

  if (error) {
    return <ErrorMessage message='An error occurred while loading attendees.' error={error} compact />;
  }
  if (loading) { return <Loading compact />; }
  if (!attendeesEvent) { return <NotFound compact />; }

  return (
    <Fragment>
      <Typography variant="h2">Attendees</Typography>
      <AttendeesList members={attendeesEvent.members} event={attendeesEvent} />
    </Fragment>
  );
};

EventAttendeesTab.propTypes = {
  event: PropTypes.object.isRequired,
};

export default EventAttendeesTab;
